module.exports = __webpack_public_path__ + "static/media/view syllabus.12e2f195.svg";